// extracted by mini-css-extract-plugin
export default {"block":"ed","loading":"fd","spinner":"gd","spin":"hd"};